export default __webpack_public_path__ + "static/media/ic_history_order.5a38480e.svg";